// File: HelpBookingDetails.jsx
import React from "react";
import "./Help.css";
import { FaBed, FaChild, FaEnvelope, FaUserEdit, FaClock } from "react-icons/fa";

const HelpBookingDetails = () => {
  return (
    <section className="helpSection p-3">
      <div className="container-xl">
        <div className="helpHeader mb-4">
          <h2 className="fw-bold text-dark">Booking Details</h2>
          <p className="text-muted">Find all information about your stay, booking changes, and confirmations.</p>
        </div>

        <div className="helpContent">
          {/* 1 */}
          <div className="helpItem">
            <div className="helpIcon"><FaBed /></div>
            <div className="helpText">
              <h5>How can I learn more about the room or property facilities?</h5>
              <p>
                All details about room features and property facilities are clearly listed in your booking confirmation. 
                You can also view them anytime by logging into your YOVHO account.
              </p>
            </div>
          </div>

          {/* 2 */}
          <div className="helpItem">
            <div className="helpIcon"><FaChild /></div>
            <div className="helpText">
              <h5>Can I request an extra bed or crib for my child?</h5>
              <p>
                This depends on each property’s policy. Extra beds or cribs may have an additional cost 
                that isn’t included in the reservation price. You can contact the property directly or ask 
                your YOVHO Captain to confirm availability before your arrival.
              </p>
            </div>
          </div>

          {/* 3 */}
          <div className="helpItem">
            <div className="helpIcon"><FaEnvelope /></div>
            <div className="helpText">
              <h5>I can’t find my confirmation email. What should I do?</h5>
              <p>
                First, check your inbox, spam, or junk folders. If you still can’t find it, simply log in 
                to your YOVHO account — all your bookings and confirmations are available there. You can also 
                contact our support team anytime for help.
              </p>
            </div>
          </div>

          {/* 4 */}
          <div className="helpItem">
            <div className="helpIcon"><FaChild /></div>
            <div className="helpText">
              <h5>Do I pay full price for my children?</h5>
              <p>
                Charges for children vary depending on the property’s policy. Some stays are free for younger children, 
                while others may apply a small additional fee. You can always confirm this directly with the property 
                or check your booking details.
              </p>
            </div>
          </div>

          {/* 5 */}
          <div className="helpItem">
            <div className="helpIcon"><FaBed /></div>
            <div className="helpText">
              <h5>What’s the difference between a Double Room and a Twin Room?</h5>
              <p>
                A Double Room has one large bed, while a Twin Room has two single beds. If the listing says “Double/Twin,” 
                it means the setup can be adjusted — just mention your preference when booking, and the property will try 
                its best to arrange it.
              </p>
            </div>
          </div>

          {/* 6 */}
          <div className="helpItem">
            <div className="helpIcon"><FaClock /></div>
            <div className="helpText">
              <h5>I’ll be arriving earlier or later than the usual check-in time. What should I do?</h5>
              <p>
                No problem — just let the property or your YOVHO Captain know your expected arrival time in advance. 
                While early or late check-in is subject to availability, the team will do their best to make your 
                arrival smooth and comfortable.
              </p>
            </div>
          </div>

          {/* 7 */}
          <div className="helpItem">
            <div className="helpIcon"><FaUserEdit /></div>
            <div className="helpText">
              <h5>Can I make changes to my booking (like changing dates)?</h5>
              <p>
                Yes, in most cases you can. Depending on the property’s policy, you can:
              </p>
              <ul>
                <li>Change check-in or check-out dates</li>
                <li>Edit guest details</li>
                <li>Update payment info</li>
                <li>Add meals or requests</li>
                <li>Contact the property directly</li>
              </ul>
              <p>
                All of these options are available through your confirmation email or your property account.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HelpBookingDetails;
